import operandType from "../../../infrastructure/constants/functions/operandType";
import assignmentHelper from "../../../infrastructure/helpers/functions/assignment/assignmentHelper";
import operandHelper from "../../../infrastructure/helpers/functions/operand/operandHelper";
import ReportCollections from "../../../infrastructure/types/Functions/ReportCollections";
import Assignment from "../../../types/functions/Assignment/Assignment";
import Condition from "../../../types/functions/Condition/Condition";
import Lookup from "../../../types/functions/Lookup";
import Operand from "../../../types/functions/Operand/Operand";
import GlobalModuleConfig from "../../../types/report/GlobalModuleConfig";
import Mode from "../../../types/report/Mode";
import RefDataSource from "../../../types/report/RefDataSource";
import ReportConfig from "../../../types/report/ReportConfig";
import ReportVariable from "../../../types/report/ReportVariable";
import UserDefinedFunction from "../../../types/report/UserDefinedFunction";

const getByConditionReferencesInGlobalConfig = (globalConfig: GlobalModuleConfig,
    condition: Condition,
    resultLookups: Lookup[],
    resulFunctions: UserDefinedFunction[],
    existinDatasourcesIds: Set<number>,
    existingInReportConfigLookupsIds: Set<number>,
    existingInReportConfigUdfsIds: Set<number>,
    existingInReportConfigVariablesIds?: Set<number>,
    resultVariables?: ReportVariable[],
) => {

    operandHelper.proceedWhitCondition(condition, ((operand: Operand) => {

        proceed(operand,
            globalConfig,
            resultLookups,
            resulFunctions,
            existinDatasourcesIds,
            existingInReportConfigLookupsIds,
            existingInReportConfigUdfsIds,
            existingInReportConfigVariablesIds,
            resultVariables
        );
    }));
}
const getByAssignmentReferencesInGlobalConfig = (globalConfig: GlobalModuleConfig,
    assignment: Assignment,
    resultLookups: Lookup[],
    resulFunctions: UserDefinedFunction[],
    existinDatasourcesIds: Set<number>,
    existingInReportConfigLookupsIds: Set<number>,
    existingInReportConfigUdfsIds: Set<number>,
    existingInReportConfigVariablesIds?: Set<number>,
    resultVariables?: ReportVariable[],
) => {

    operandHelper.proceedWhitAssignment(assignment, ((operand: Operand) => {

        proceed(operand,
            globalConfig,
            resultLookups,
            resulFunctions,
            existinDatasourcesIds,
            existingInReportConfigLookupsIds,
            existingInReportConfigUdfsIds,
            existingInReportConfigVariablesIds,
            resultVariables
        );
    }));
}

const proceed = (operand: Operand,
    globalConfig: GlobalModuleConfig,
    resultLookups: Lookup[],
    resulFunctions: UserDefinedFunction[],
    existinDatasourcesIds: Set<number>,
    existingInReportConfigLookupsIds: Set<number>,
    existingInReportConfigUdfsIds: Set<number>,
    existingInReportConfigVariablesIds?: Set<number>,
    resultVariables?: ReportVariable[],
) => {

    if (operand.lookupNumber) {

        let currentLookup = globalConfig.lookups.find(x => x.number === operand.lookupNumber) as Lookup;

        if (!existingInReportConfigLookupsIds.has(currentLookup?.id as number)) {
            resultLookups.push(currentLookup);

            existingInReportConfigLookupsIds.add(currentLookup?.id as number);

            existinDatasourcesIds.add(currentLookup.dataSource1Id as number);
            existinDatasourcesIds.add(currentLookup.dataSource2Id as number);

            getByConditionReferencesInGlobalConfig(globalConfig,
                currentLookup.condition,
                resultLookups,
                resulFunctions,
                existinDatasourcesIds,
                existingInReportConfigLookupsIds,
                existingInReportConfigUdfsIds,
                existingInReportConfigVariablesIds,
                resultVariables
            );
        }
    }

    if (operand.variableNumber) {

        let currentVariable = globalConfig.variables.find(x => x.number === operand.variableNumber) as ReportVariable;

        if (!existingInReportConfigVariablesIds?.has(currentVariable?.id as number)) {
            resultVariables?.push(currentVariable);

            if (currentVariable.dataSourceId && !existinDatasourcesIds.has(currentVariable.dataSourceId)) {
                existinDatasourcesIds.add(currentVariable.dataSourceId);
            }

            existingInReportConfigVariablesIds?.add(currentVariable?.id as number);

            getByAssignmentReferencesInGlobalConfig(globalConfig,
                currentVariable.assignment,
                resultLookups,
                resulFunctions,
                existinDatasourcesIds,
                existingInReportConfigLookupsIds,
                existingInReportConfigUdfsIds,
                existingInReportConfigVariablesIds,
                resultVariables
            );
        }
    }

    if (operand.functionNumber) {

        let currentFunction = globalConfig.userDefinedFunctions.find(x => x.number === operand.functionNumber) as UserDefinedFunction;

        if (!existingInReportConfigUdfsIds.has(currentFunction?.id as number)) {
            resulFunctions.push(currentFunction);

            existingInReportConfigUdfsIds.add(currentFunction?.id as number);

            getByAssignmentReferencesInGlobalConfig(globalConfig,
                currentFunction.assignment,
                resultLookups,
                resulFunctions,
                existinDatasourcesIds,
                existingInReportConfigLookupsIds,
                existingInReportConfigUdfsIds,
                existingInReportConfigVariablesIds,
                resultVariables
            );
        }

    }
}

const getGlobalModuleDetaSourceValues = (collections: ReportCollections, reportConfig: ReportConfig): string[] => {

    let globalModuleDataSourcesIds = collections?.globalModuleDataSources?.map(x => (x.id || '')?.toString()) || [];

    if (!globalModuleDataSourcesIds.length) {
        reportConfig.lookups.filter(x => x.mode === Mode.Global).forEach((lookup) => {
            globalModuleDataSourcesIds.push((lookup.dataSource1Id as number).toString());
            globalModuleDataSourcesIds.push((lookup.dataSource2Id as number).toString());
        })
    }

    return globalModuleDataSourcesIds;
}

export { getByAssignmentReferencesInGlobalConfig, getByConditionReferencesInGlobalConfig, getGlobalModuleDetaSourceValues }
